import React, { useEffect } from "react";
import styled from "@mui/system/styled";
import { useCallCenterForm } from "../hooks/useCallCenterForm";

import TextField from "@mui/material/TextField";

const TextInput = styled(TextField)(() => ({
  padding: "4px",
}));

const FirstName = () => {
  const { errors, formValues, handleInputChange, handleInputFocus } =
    useCallCenterForm();

  useEffect(() => {}, [formValues]);

  const handleErrorText = () => {
    if (!errors?.first_name) {
      return null;
    }

    return errors?.first_name;
  };

  return (
    <TextInput
      sx={{ flex: 1 }}
      name="first_name"
      label="First Name"
      onChange={handleInputChange}
      onFocus={handleInputFocus}
      value={formValues?.first_name}
      helperText={handleErrorText()}
      error={!!errors?.first_name}
    />
  );
};

export default FirstName;
